import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import LineSendPanel from './LineSendPanel';
import { useState } from 'react';
import { useUIStore } from '../../store/authStore';
import { Plus } from 'lucide-react';
import { cn } from '../../lib/utils';

// Font size scaling - applied to the main content area
const fontSizeStyles = {
  small: { fontSize: '14px' },
  medium: { fontSize: '16px' },
  large: { fontSize: '18px' },
};

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [linePanelOpen, setLinePanelOpen] = useState(false);
  const { fontSize } = useUIStore();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // Hide FAB on report form page
  const showFab = !location.pathname.includes('/reports/new') && !location.pathname.includes('/edit');

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

      <div className="flex">
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          onOpenLinePanel={() => setLinePanelOpen(true)}
        />

        <LineSendPanel
          isOpen={linePanelOpen}
          onClose={() => setLinePanelOpen(false)}
        />

        <main
          className="flex-1 min-w-0 p-4 lg:p-6 lg:ml-64 mt-16"
          style={fontSizeStyles[fontSize]}
        >
          <Outlet />
        </main>
      </div>

      {/* Floating Action Button for New Report */}
      {showFab && (
        <button
          onClick={() => navigate('/reports/new')}
          className="fixed right-6 bottom-6 w-14 h-14 bg-tpc-blue hover:bg-tpc-blue-dark text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center z-50 group"
          title={t('nav.newReport')}
        >
          <Plus className="w-6 h-6 group-hover:rotate-90 transition-transform duration-200" />
        </button>
      )}
    </div>
  );
}
